import { CreditCardIcon, PlusIcon } from "lucide-react";

import { Button } from "@/components/button";

export function AddBackupMethodCard({ onAdd }: { onAdd: () => void }) {
  return (
    <div className="flex min-w-0 flex-1 flex-col items-center justify-center gap-lg rounded-md border border-dashed border-fg-warning-secondary bg-utility-warning-50 px-3xl py-xl text-center">
      <div className="flex flex-col items-center gap-md">
        <div className="flex size-12 items-center justify-center rounded-lg bg-bg-warning-secondary">
          <CreditCardIcon
            aria-hidden="true"
            className="text-fg-warning-primary"
            size={24}
          />
        </div>
        <div className="flex max-w-120 flex-col gap-xs">
          <span className="text-md font-semibold text-text-primary">
            Add a backup payment method
          </span>
          <p className="text-sm text-text-tertiary">
            Avoid interruptions to your service by adding a backup payment
            method. If your primary payment method fails, we&apos;ll
            automatically charge your backup method to keep your subscription
            active.
          </p>
        </div>
      </div>
      <Button
        className="bg-fg-warning-primary text-text-white hover:bg-utility-warning-700 hover:text-text-white"
        onPress={onAdd}
        size="lg"
      >
        <PlusIcon />
        Add backup method
      </Button>
    </div>
  );
}
